import React from 'react';
import PropTypes from 'prop-types';

// University student-employment requirements, shown before faculty name a
// nominee. HR revises these, so re-read the source page when touching them:
// https://www.msudenver.edu/human-resources/student-employment/opportunities/requirements/
export const STUDENT_EMPLOYMENT_REQUIREMENTS_URL =
    'https://www.msudenver.edu/human-resources/student-employment/opportunities/requirements/';
export const STUDENT_EMPLOYMENT_REQUIREMENTS = [
    'At least 18 years old.',
    'Enrolled in at least 6 credit hours in fall and spring (the final semester before graduation is exempt).',
    'International students: enrolled full time (12 credit hours undergraduate, 6 graduate), an Employment Eligibility Form each semester, and a Social Security number.',
    'Semester GPA of at least 2.0 (one semester of probation allowed).',
    'Graduates may work one semester after graduation in the same department.',
];

/**
 * The "Before you name a student" box, shown above the LA nominee rows
 * wherever faculty name one: the wizard's Program Questionnaire and the
 * nominee panel on a submitted application. `headingId` labels the region,
 * so two on one page need different ones.
 */
function StudentEmploymentRequirements({ headingId }) {
    return (
        // A plain section, not an Alert: Alert is role="alert", which would
        // announce this reference text as an interruption
        <section
            aria-labelledby={headingId}
            className="border rounded bg-light p-3 mb-3"
        >
            <h3 id={headingId} className="h6">
                Before you name a student
            </h3>
            <p className="small mb-2">
                These are the university&apos;s student-employment requirements.
                Human Resources verifies them when the student is hired.
            </p>
            <ul className="small mb-2">
                {STUDENT_EMPLOYMENT_REQUIREMENTS.map((requirement) => (
                    <li key={requirement}>{requirement}</li>
                ))}
            </ul>
            <a
                href={STUDENT_EMPLOYMENT_REQUIREMENTS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="small"
            >
                Student employment requirements (MSU Denver Human Resources)
            </a>
        </section>
    );
}

StudentEmploymentRequirements.propTypes = {
    headingId: PropTypes.string.isRequired,
};

export default StudentEmploymentRequirements;
